import { useTranslate } from '@repo/shared/hooks'
import { z } from 'zod'

export const useForgotPasswordSchema = () => {
  const { t } = useTranslate()

  const validationRules = {
    minLength: 8,
    lowercase: /[a-z]/,
    uppercase: /[A-Z]/,
    number: /\d/,
  }

  const forgotPasswordSchema = z
    .object({
      password: z
        .string({
          required_error: t('common_validation_required'),
        })
        .min(validationRules.minLength, {
          message: t('common_validation_minLength'),
        })
        .regex(validationRules.lowercase, {
          message: t('common_validation_lowercase'),
        })
        .regex(validationRules.uppercase, {
          message: t('common_validation_uppercase'),
        })
        .regex(validationRules.number, {
          message: t('common_validation_number'),
        }),
      confirmPassword: z.string({
        message: t('common_validation_confirmPassword_required'),
      }),
    })
    .refine((data) => data.password === data.confirmPassword, {
      message: t('common_validation_match'),
      path: ['confirmPassword'],
    })

  return { forgotPasswordSchema, validationRules }
}
